import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Update+Shipping+Address+on+Profile+API

function updateShippingAddress(addressData) {
    let url = '/api/users/profiles/address';
    const { enableProfileShippingGroup = false } = Sephora.configurationSettings;

    if (enableProfileShippingGroup && cookieUtils.isRCPShippingAPIEnabled()) {
        url = '/gway/v2/users/profiles/address';
    }

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify(addressData)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default updateShippingAddress;
